import uuid from 'uuid/v4';

export const NOTIFICATION_SHOW = 'NOTIFICATION_SHOW';
export const NOTIFICATION_COMPLETED = 'NOTIFICATION_COMPLETED';

export const SOTY_VOTE = 'SOTY_VOTE';
export const SOTY_VOTE_SUCCESS = 'SOTY_VOTE_SUCCESS';
export const SOTY_VOTE_FAILED = 'SOTY_VOTE_FAILED';
export const SOTY_TOKEN_RECEIVE = 'SOTY_TOKEN_RECEIVE';
export const SOTY_HISTORY_RECEIVE = 'SOTY_HISTORY_RECEIVE';
export const SOTY_VOTE_POPUP_CLOSED = 'SOTY_VOTE_POPUP_CLOSED';
export const SOTY_VOTE_POPUP_OPENED = 'SOTY_VOTE_POPUP_OPENED';

export const showNotification = (type, text, id = uuid(), handlers) => ({
  type: NOTIFICATION_SHOW,
  notification: {
    id,
    type,
    text,
    handlers,
  },
});

export const notificationCompleted = () => ({
  type: NOTIFICATION_COMPLETED,
});

export const sotyVote = (oldToken, email, user, categoryId, storeId) => ({
  type: SOTY_VOTE,
  oldToken,
  email,
  user,
  categoryId,
  storeId,
});

export const sotyVoteFailed = error => ({
  type: SOTY_VOTE_FAILED,
  error,
});

export const sotyVoteSuccess = (email, categoryId, storeId) => ({
  type: SOTY_VOTE_SUCCESS,
  email,
  categoryId,
  storeId,
});

export const sotyTokenReceived = (token, email) => ({
  type: SOTY_TOKEN_RECEIVE,
  token,
  email,
});

export const sotyHistoryReceived = history => ({
  type: SOTY_HISTORY_RECEIVE,
  history,
});

export const sotyVotePopupClosed = () => ({
  type: SOTY_VOTE_POPUP_CLOSED,
});

export const sotyVotePopupOpened = () => ({
  type: SOTY_VOTE_POPUP_OPENED,
});

export default {
  showNotification,
  notificationCompleted,
  sotyVote,
  sotyVoteSuccess,
  sotyVoteFailed,
  sotyTokenReceived,
  sotyHistoryReceived,
  sotyVotePopupClosed,
  sotyVotePopupOpened,
};
